import React from 'react';
import { Pagination } from '@mui/material';
import {
    Location,
    PaginationMeta,
    PaginationOrder,
    Practitioner,
    PractitionerCounts,
    PractitionerStatus,
} from '@/common/types';
import { PaginationWrapper } from '@/components/common/Table/styles';
import { Tabs, Tab } from '@/components/common/Tabs/styles';
import { OrganizationListWrapper } from '../styles';
import { EmptyPractitioners } from './EmptyPractitioners';
import { PractitionerRow } from './PractitionerRow';
import { PractitionersListHeader } from './PractitionersListHeader';

interface Props {
    practitioners?: Practitioner[];
    locations?: Location[];
    supportsSSO: boolean;
    status: PractitionerStatus;
    counts: PractitionerCounts;
    page: number;
    order: PaginationOrder;
    metadata?: PaginationMeta;
    onStatusChange: (status: PractitionerStatus) => void;
    onPageChange: (page: number) => void;
    onToggleOrder: () => void;
}

export const PractitionersList = (props: Props) => {
    const {
        practitioners,
        locations,
        supportsSSO,
        status,
        counts,
        page,
        order,
        metadata,
        onStatusChange,
        onPageChange,
        onToggleOrder,
    } = props;

    const handleTabChange = (_: React.ChangeEvent, newValue: PractitionerStatus) => {
        onStatusChange(newValue);
    };

    const handlePageChange = (_: React.ChangeEvent<unknown>, value: number) => {
        onPageChange(value);
    };

    const rows = (practitioners || []).map((practitioner) => (
        <PractitionerRow key={practitioner.id} practitioner={practitioner} locations={locations} />
    ));

    const showPagination = metadata && metadata.totalPages > 1;
    const hasAnyPractitioners = counts.current + counts.invited > 0;

    return (
        <OrganizationListWrapper data-cy="practitioner-list">
            <Tabs value={status} onChange={handleTabChange}>
                <Tab label={`Current Users (${counts.current})`} value={PractitionerStatus.CURRENT} />
                <Tab label={`Invited Users (${counts.invited})`} value={PractitionerStatus.INVITED} />
            </Tabs>
            <PractitionersListHeader order={order} onToggleOrder={onToggleOrder} />
            {practitioners ? (
                rows.length > 0 ? (
                    rows
                ) : !hasAnyPractitioners ? (
                    <EmptyPractitioners supportsSSO={supportsSSO} />
                ) : null
            ) : null}
            {showPagination && (
                <PaginationWrapper>
                    <Pagination
                        count={metadata!.totalPages}
                        page={page}
                        color="primary"
                        variant="outlined"
                        shape="rounded"
                        onChange={handlePageChange}
                    />
                </PaginationWrapper>
            )}
        </OrganizationListWrapper>
    );
};
